import Carousel from './components/Carousel.js';
import Cookies from './components/Cookies.js';
import Jarallax from './components/Jarallax.js';
import SearchBlogPosts from './components/SearchBlogPosts.js';
import SearchFaqQuestions from './components/SearchFaqQuestions.js';
import ZohoForm from './components/ZohoForm.js';
import Header from './components/Header.js';
import Timeline from './components/Timeline.js';
import Accordeon from './components/Accordeon.js';
export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Carousel,
      Cookies,
      Jarallax,
      SearchBlogPosts,
      SearchFaqQuestions,
      ZohoForm,
      Header,
      Timeline,
      Accordeon,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      }
    }
  }
}
